export default __webpack_public_path__ + "static/media/icon-12.04db5df8.svg";